module.exports = __webpack_public_path__ + "static/media/ic_arrow_more.d9318a5c.svg";